// @ts-nocheck
export const EmptyComponent = () => <></>;
